import { ISimejiItem } from '@template/Simeji/simejiStatus.interface';
import React from 'react';
import styled from 'styled-components';

const LegSec = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  img,
  svg {
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    user-select: none;
  }
`;

export interface Props {
  data: ISimejiItem;
  skinColor?: string;
}

function Legs({ skinColor, data }: Props) {
  const { rightPants, leftPants } = data;
  return (
    <LegSec className="legs">
      <svg
        width="100"
        height="120"
        viewBox="0 0 100 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        color={data.lineColor}
      >
        <g>
          {/* 왼 다리 */}
          <g className="left-leg">
            <path
              d="M62.8582 109.118C63.6825 101.706 60.7975 98 57.1915 98C51.5247 99.2353 53.0702 106.029 53.5854 111.588C54.1005 117.147 55.6459 119 58.737 119C60.7976 119 61.8279 118.382 62.8582 109.118Z"
              fill={skinColor}
              stroke="currentColor"
            />
          </g>
          {/* 오른 다리 */}
          <g className="right-leg">
            <path
              d="M39.1418 109.118C38.3175 101.706 41.2025 98 44.8085 98C50.4753 99.2353 48.9298 106.029 48.4146 111.588C47.8995 117.147 46.3541 119 43.263 119C41.2024 119 40.1721 118.382 39.1418 109.118Z"
              fill={skinColor}
              stroke="currentColor"
            />
          </g>
        </g>
      </svg>

      <img className="left-leg" src={rightPants} alt="" />
      <img className="right-leg" src={leftPants} alt="" />
    </LegSec>
  );
}

export default Legs;
